import { search_asp, unique, deepcopy, trimFieldString, parseColor, makeGradient, arrayMode, arrayCount } from "../util.js";


export function translateMakeHeatmapNoAgg(tech, args, line, parsed, source, mapping, processed, config) {
  // do(make_heatmap_no_agg,c1,r0).
  let rules = [];
  // layout change
  let is_split, keep_split;
  search_asp(parsed, 'do(make_heatmap_adjust_split,', 'startsWith').forEach(p => {
    is_split = true;
    if (p.args[1] === 'keep_multiple') keep_split = true;
    else if (p.args[1] === 'to_row') keep_split = false;
  });
  let entity, rc, splitField;
  if (mapping[args[0]]["layout.row"] !== undefined) rc = "row";
  else if (mapping[args[0]]["layout.column"] !== undefined) rc = "column";
  if (is_split && source?.layout?.split !== undefined) splitField = deepcopy(source?.layout?.split);
  entity = source?.layout?.[rc]?.[mapping[args[0]]["layout." + rc]];
  if (entity) {
    let field = (entity.constructor.name === "Array" ? entity[0] : entity);
    field = field.field || field;
    rules.push({
      category: "recommender",
      description: `Remove ${rc} field`,
      specifier: {
        role: "view." + rc,
        field: field
      },
      action: "remove"
    })
    // mark type change
    rules.push({
      category: "recommender",
      description: `Change mark to rect`,
      specifier: {
        role: "mark",
        mark: source?.layer?.[0]?.mark?.type
      },
      action: "modify",
      option: {
        type: "tick",
        stroke: null
      }
    })
    // scale change
    let rule_color = {
      category: "recommender",
      description: `Add fill channel for ${field}`,
      specifier: {
        role: "mark",
        mark: "tick"
      },
      action: "add",
      option: {
        channel: "fill",
        fill: {
          field: field
        }
      }
    };
    let new_color_scale;
    source.layer?.forEach(layer => {
      if (new_color_scale) return;
      if (layer.mark.color?.scale?.range != undefined) new_color_scale = layer.mark.color.scale.range;
      else if (layer.mark.fill?.value) {
        new_color_scale = makeGradient(layer.mark.fill.value);
      } else if (layer.mark.stroke?.value) {
        new_color_scale = makeGradient(layer.mark.stroke.value);
      }
    });
    new_color_scale = unique(new_color_scale);
    if (new_color_scale !== undefined && new_color_scale.length >= 2) {
      rule_color.option.fill.scale = { range: new_color_scale };
    }
    if (rule_color.option.fill.scale?.range?.length == 0) {
      delete rule_color.option.fill.scale.range;
    }
    rules.push(rule_color);

    if (is_split && splitField.field !== undefined && keep_split == false) {
      let rule_split = {
        category: "recommender",
        description: `Change from repated to single`,
        specifier: { role: "view" },
        action: "modify",
        option: {
          composition: "single",
          split: null,
          nColumns: null
        }
      };
      rules.push(rule_split);
      let rule_axis = {
        category: "recommender",
        description: `Change split field to row field: ${splitField.field}`,
        specifier: { role: "view" },
        action: "add",
        option: {
          role: "row",
          field: splitField.field,
          type: "nominal"
        }
      };
      if (splitField.values !== undefined) {
        rule_axis.option.sort = { sortBy: deepcopy(splitField.values) };
      }
      rules.push(rule_axis);
      if (splitField.label !== undefined) {
        let rule_label = {
          category: "recommender",
          description: `Add axis labels for ${splitField.field}`,
          specifier: { role: "layer", index: 0 },
          action: "add",
          option: { role: "text", text: {} }
        };
        rule_label.option.text = deepcopy(splitField.label);
        if (!rule_label.option.text.items || rule_label.option.text.items?.length == 0) rule_label.option.text.items = [{}];
        rule_label.option.text.type = "axis";
        rule_label.option.text.field = splitField.field;
        let pr;
        if ((pr = search_asp(parsed, "do(reduce_text_size", "startsWith")[0], pr)) {
          let text_map = mapping[pr.args[1]];
          let scale_factor;
          search_asp(parsed, "do(disproportionate_resizing", "startsWith").forEach((p) => {
            scale_factor = source.layout.width / parseFloat(p.args[1]);
          });
          search_asp(parsed, "do(proportionate_resizing", "startsWith").forEach((p) => {
            scale_factor = source.layout.width / parseFloat(p.args[1]);
          });
          if (scale_factor && text_map.type === "split.label") {
            rule_label.option.text.items.forEach((textElem) => {
              let split_font_size = textElem.fontSize || 16;
              textElem.fontSize = Math.max(split_font_size / scale_factor, 12);
            });
          }
        }
        rule_label.option.text.anchor = null;
        rule_label.option.text.align = "right";
        if (splitField.values !== undefined) rule_label.option.text.values = deepcopy(splitField.values);
        rules.push(rule_label);
      }
    } else if (is_split && splitField.field !== undefined) {
      let rule_split = {
        category: "recommender",
        description: `Set facet columns as 1`,
        specifier: { role: "view" },
        action: "modify",
        option: {
          nColumns: 1
        }
      };
      rules.push(rule_split);
    }
  }
  return rules;
}

export function translateMakeHeatmapNoAggDup(tech, args, line, parsed, source, mapping, processed, config) {
  // do(make_heatmap_no_agg_dup,c1,r0).
  let rules = [];
  // layout change
  let is_split, keep_split;
  search_asp(parsed, 'do(make_heatmap_adjust_split,', 'startsWith').forEach(p => {
    is_split = true;
    if (p.args[1] === 'keep_multiple') keep_split = true;
    else if (p.args[1] === 'to_row') keep_split = false;
  });

  let entity, rc, splitField;
  if (mapping[args[0]]["layout.row"] !== undefined) rc = "row";
  else if (mapping[args[0]]["layout.column"] !== undefined) rc = "column";
  if (is_split && source?.layout?.split !== undefined) splitField = deepcopy(source?.layout?.split);
  entity = source?.layout?.[rc]?.[mapping[args[0]]["layout." + rc]];
  if (entity) {
    let field = (entity.constructor.name === "Array" ? entity[0] : entity);
    field = field.field || field;
    rules.push({
      category: "recommender",
      description: `Remove ${rc} field`,
      specifier: {
        role: "view." + rc,
        field: field
      },
      action: "remove"
    })
    // mark type change
    rules.push({
      category: "recommender",
      description: `Change mark to rect`,
      specifier: {
        role: "mark",
        mark: source?.layer?.[0]?.mark?.type
      },
      action: "modify",
      option: {
        type: "rect"
      }
    })
    // remove mark property channels
    Object.keys(source?.layer?.[0]?.mark)?.forEach(property => {
      if (["size", "color", "fill", "stroke", "strokeWidth", "shape"].includes(property)) {
        if (source.layer[0].mark[property].value === undefined) {
          rules.push({
            category: "recommender",
            description: `Remove ${property} channel for rect`,
            specifier: {
              role: "mark",
              mark: "rect"
            },
            action: "remove",
            option: {
              channel: property
            }
          });
        }
      }
    });
    // scale change
    let rule_color = {
      category: "recommender",
      description: `Add fill channel for ${field}`,
      specifier: {
        role: "mark",
        mark: "rect"
      },
      action: "add",
      option: {
        channel: "fill",
        fill: {
          field: field
        }
      }
    };
    let new_color_scale, from, flayer;
    source.layer?.forEach(layer => {
      if (new_color_scale) return;
      if (layer.mark.color?.scale?.range != undefined) {
        new_color_scale = layer.mark.color.scale.range;
        from = "color";
        flayer = layer;
      } else if (layer.mark.fill?.scale?.range != undefined) {
        new_color_scale = layer.mark.fill.scale.range;
        from = "fill";
        flayer = layer;
      } else if (layer.mark.stroke?.scale?.range != undefined) {
        new_color_scale = layer.mark.stroke.scale.range;
        from = "stroke";
        flayer = layer;
      }
    });
    if (new_color_scale !== undefined) {
      let ftype = source.datatype[flayer.mark[from].field]?.type
      if (ftype === "quantitative" || ftype === "temporal") {
        new_color_scale = unique(new_color_scale);
      } else {
        let mode = arrayMode(flayer.mark[from].scale.range)
        new_color_scale = makeGradient(mode);
      }
      rule_color.option.fill.scale = { range: new_color_scale };
    } else {
      rule_color.option.fill.scale = { domain: null, scheme: "viridis" };
    }
    rules.push(rule_color);

    if (from === "fill" && flayer.mark.fill?.scale?.range) {
      let stroke = deepcopy(flayer.mark.fill)
      let rule_stroke = {
        category: "recommender",
        description: `Add stroke channel for ${field}`,
        specifier: {
          role: "mark",
          mark: "rect"
        },
        action: "add",
        option: {
          channel: "stroke",
          stroke
        }
      }
      let rangeCounts = arrayCount(stroke.scale.range);
      let forEmphasis = [];
      Object.keys(rangeCounts)?.forEach((v) => {
        if (rangeCounts[v] == 1) forEmphasis.push(v);
      });
      if (forEmphasis.length < stroke.scale.range.length) {
        let newDomain = [];
        let newRange = [];
        stroke.scale.range.forEach((r, i) => {
          if (forEmphasis.includes(r)) {
            newDomain.push(stroke.scale.domain[i]);
            newRange.push(stroke.scale.range[i]);
          } else {
            newDomain.push(stroke.scale.domain[i]);
            newRange.push("rgba(255,255,255,0)");
          }
        });
        rule_stroke.option.stroke.scale.domain = newDomain;
        rule_stroke.option.stroke.scale.range = newRange;
      }
      rules.push(rule_stroke);
    }

    if (source.layout.haxis.domain) {
      let rule_axis = {
        category: "recommender",
        description: "Modify axis domain",
        specifier: {
          role: "view.hAxis",
        },
        action: "modify",
        option: {
          domain: null
        }
      };
      rules.push(rule_axis);
    }

    if (is_split && splitField.field !== undefined && keep_split == false) {
      let rule_split = {
        category: "recommender",
        description: `Change from repated to single`,
        specifier: { role: "view" },
        action: "modify",
        option: {
          composition: "single",
          split: null,
          nColumns: null
        }
      };
      rules.push(rule_split);
      let rule_axis = {
        category: "recommender",
        description: `Change split field to row field: ${splitField.field}`,
        specifier: { role: "view" },
        action: "add",
        option: {
          role: "row",
          field: splitField.field,
          type: "nominal"
        }
      };
      if (splitField.values !== undefined) {
        rule_axis.option.sortBy = deepcopy(splitField.values);
      }
      rules.push(rule_axis);
      if (splitField.label !== undefined) {
        let rule_label = {
          category: "recommender",
          description: `Add axis labels for ${splitField.field}`,
          specifier: { role: "layer", index: 0 },
          action: "add",
          option: { text: {} }
        };
        rule_label.option.text = deepcopy(splitField.label);
        rule_label.option.text.items = [{}];
        rule_label.option.text.type = "axis";
        rule_label.option.text.field = splitField.field;
        if (splitField.values !== undefined) rule_label.option.text.values = deepcopy(splitField.values);
        rules.push(rule_label);
      }
    } else if (is_split && splitField.field !== undefined) {
      let rule_split = {
        category: "recommender",
        description: `Set facet columns as 1`,
        specifier: { role: "view" },
        action: "modify",
        option: {
          nColumns: 1
        }
      };
      rules.push(rule_split);
    }
  }
  return rules;
}

export function translateMakeHeatmapNonTabularNoAggConvertChannel(tech, args, line, parsed, source, mapping, processed, config) {
  // do(make_heatmap_nontabular_no_agg_convert_channel,r0,c0,color)
  let rules = [];
  let entity, entity2, rc, rc2;
  if (mapping[args[0]]["layout.row"] !== undefined) rc = "row";
  else if (mapping[args[0]]["layout.column"] !== undefined) rc = "column";
  entity = source?.layout?.[rc]?.[mapping[args[0]]["layout." + rc]];
  rc2 = (rc === "column" ? "row" : "column");
  entity2 = source?.layout?.[rc2];
  if (entity2) entity2 = entity2[entity2.length - 1]
  let channel = source?.layer?.[0]?.mark?.[args[2]];
  if (channel && entity && channel.field && entity2) {
    // layout change;
    let field = (entity.constructor.name === "Array" ? entity[0] : entity);
    field = field.field || field;
    let rule_rc = {
      category: "recommender",
      description: `Set ${field} as ${rc}`,
      specifier: {
        role: "view." + rc,
        field: field
      },
      action: "modify",
      option: {
        field: channel.field,
        type: 'nominal',
        scale: {
          domain: null,
          range: null
        }
      }
    };
    rules.push(rule_rc);
    let field2 = (entity2.constructor.name === "Array" ? entity2[0] : entity2);
    field2 = field2.field || field2;
    let rule_rc2 = {
      category: "recommender",
      description: `Set ${rc2} encoding scale as ordinal`,
      specifier: {
        role: "view." + rc2,
        field: field2
      },
      action: "modify",
      option: {
        type: 'ordinal'
      }
    };
    rules.push(rule_rc2);
    // mark type change; new channel assignment
    let rule_ch = {
      category: "recommender",
      description: `Change mark type to rect`,
      specifier: {
        role: "mark",
        mark: source.layer[0].mark.type
      },
      action: "modify",
      option: {
        type: "rect"
      }
    };
    rule_ch.option[args[2]] = {
      field: field,
      type: "quantitative",
      scale: {
        domain: null
      }
    };
    rules.push(rule_ch);
    let rule_le = {
      category: "recommender",
      description: `Add legend for ${field}`,
      specifier: {
        role: "layer",
        mark: "rect"
      },
      action: "add",
      option: {
        legend: {
          field: field,
          direction: "horizontal",
          orient: "top",
          title: {
            value: field,
          }
        }
      }
    };
    let old_axis_label = source.layer[0].text.filter(d => d.type === "on-axis" && d.field === field);
    let rule_ax_lab;
    if (old_axis_label.length > 0) {
      if (old_axis_label[0].items !== undefined) rule_le.option.legend.items = old_axis_label[0].items;
      if (old_axis_label[0].values !== undefined) rule_le.option.legend.values = old_axis_label[0].values;
      rule_ax_lab = {
        category: "recommender",
        description: `Remove axis label for ${field}`,
        specifier: { role: "axis.label", field: field },
        action: "remove"
      }
    }
    rules.push(rule_le);
    if (rule_ax_lab !== undefined) rules.push(rule_ax_lab);
    let old_mark_label = source.layer[0].text.filter(d => d.type === "on-mark" && d.field === channel.field);
    let rule_mark_lab;
    if (old_mark_label.length > 0) {
      rule_mark_lab = {
        category: "recommender",
        description: `Convert mark label to axis label`,
        specifier: { role: "mark.label", mark: "rect" },
        action: "replace",
        option: {
          to: {
            role: "axis.label",
            fontColor: null,
            textAlign: "right"
          }
        }
      }
    }
    if (rule_mark_lab) rules.push(rule_mark_lab);
  }
  return rules;
}

export function translateMAkeHeatmapNonTabularRemoveNominalChannels(tech, args, line, parsed, source, mapping, processed, config) {
  // do(make_heatmap_nontabular_with_remove_nominal_channels,r0,c0,"justice"). 
  let rules = [];
  let entity, entity2, rc, rc2;
  if (mapping[args[0]]["layout.row"] !== undefined) rc = "row";
  else if (mapping[args[0]]["layout.column"] !== undefined) rc = "column";
  entity = source?.layout?.[rc]?.[mapping[args[0]]["layout." + rc]];
  rc2 = (rc === "column" ? "row" : "column");
  entity2 = source?.layout?.[rc2];
  if (entity2) entity2 = entity2[entity2.length - 1]

  let fieldToRC = trimFieldString(args[2]);
  let mark = source?.layer?.[0]?.mark || {}
  let channels = Object.keys(mark)?.filter(d => mark[d].field !== undefined || mark[d].aggregate !== undefined)
  if (fieldToRC && entity && entity2 && channels) {
    // layout change;
    let field = (entity.constructor.name === "Array" ? entity[0] : entity);
    field = field.field || field;
    let rule_rc = {
      category: "recommender",
      description: `Set ${field} as ${rc}`,
      specifier: {
        role: "view." + rc,
        field: field
      },
      action: "modify",
      option: {
        field: fieldToRC,
        type: 'nominal',
        scale: {
          domain: null,
          range: null
        }
      }
    };
    rules.push(rule_rc);
    let field2 = (entity2.constructor.name === "Array" ? entity2[0] : entity2);
    field2 = field2.field || field2;
    let rule_rc2 = {
      category: "recommender",
      description: `Set ${rc2} encoding scale as ordinal`,
      specifier: {
        role: "view." + rc2,
        field: field2
      },
      action: "modify",
      option: {
        type: 'ordinal'
      }
    };
    rules.push(rule_rc2);
    // remove channels
    channels.forEach(property => {
      let rule_ch0 = {
        category: "recommender",
        description: `Remove a channel ${property}`,
        specifier: {
          role: "mark",
          mark: source.layer[0].mark.type
        },
        action: "remove",
        option: {
          channel: property
        }
      };
      rules.push(rule_ch0);
    })
    // mark type change; new channel assignment
    let rule_ch = {
      category: "recommender",
      description: `Change mark type to rect`,
      specifier: {
        role: "mark",
        mark: source.layer[0].mark.type
      },
      action: "modify",
      option: {
        mark: "rect"
      }
    };
    rule_ch.option.fill = {
      field: field,
      type: "quantitative",
      scale: {
        domain: null
      }
    };
    // color scaling
    let domain_has_zero = false;
    if (entity.scale.domain) {
      if (Math.sign(Math.min(...entity.scale.domain)) != Math.sign(Math.max(...entity.scale.domain))) {
        domain_has_zero = true;
      }
      if (domain_has_zero) {
        rule_ch.option.fill.scale.domain = [entity.scale.domain[0], 0, entity.scale.domain[1]];
      }
      else {
        rule_ch.option.fill.scale.domain = [entity.scale.domain[0], entity.scale.domain[1]];
      }
    }
    let extColorCh;
    if ((mark.fill?.field !== undefined || mark.fill?.aggregate !== undefined) && mark.fill.scale?.range !== undefined) {
      extColorCh = "fill";
    } else if ((mark.stroke?.field !== undefined || mark.stroke?.aggregate !== undefined) && mark.stroke.scale?.range !== undefined) {
      extColorCh = "stroke"
    } else if ((mark.color?.field !== undefined || mark.color?.aggregate !== undefined) && mark.color.scale?.range !== undefined) {
      extColorCh = "color"
    }
    let new_range;
    if (extColorCh) {
      let old_range = mark[extColorCh].scale.range;
      new_range = [];
      let colorStd = old_range.map(d => parseColor(d)).map(d => {
        let m = (d.r + d.g + d.b) / 3;
        let s = Math.abs(d.r - m) + Math.abs(d.g - m) + Math.abs(d.b - m);
        return s;
      })
      let sortedStd = [...colorStd].sort((a, b) => b - a);
      let point1 = old_range.filter((d, i) => colorStd[i] == sortedStd[0])[0];
      let point2 = colorStd[1] > 10 ? old_range.filter((d, i) => colorStd[i] == sortedStd[1])[0] : getComplementaryColor(point1);
      if (domain_has_zero) {
        let center = (colorStd.length > 1 ? old_range.filter((d, i) => colorStd[i] == sortedStd[sortedStd.length - 1])[0] : "#f0f0f0");
        new_range = [point1, center, point2];
      } else {
        new_range = [point1, point2];
      }
    } else {
      if (domain_has_zero) {
        new_range = { scheme: "RdBu" }
      }
    }
    if (new_range) {
      rule_ch.option.fill.scale.range = new_range;
    }
    rules.push(rule_ch);
    let rule_le = {
      category: "recommender",
      description: `Add legend for ${field}`,
      specifier: {
        role: "layer",
        mark: "rect"
      },
      action: "add",
      option: {
        legend: {
          field: field,
          direction: "horizontal",
          orient: "top",
          title: {
            value: field,
          }
        }
      }
    };
    let old_axis_label = source.layer[0].text.filter(d => d.type === "on-axis" && d.field === field);
    let rule_ax_lab;
    if (old_axis_label.length > 0) {
      if (old_axis_label[0].items !== undefined) rule_le.option.legend.items = old_axis_label[0].items;
      if (old_axis_label[0].values !== undefined) rule_le.option.legend.values = old_axis_label[0].values;
      rule_ax_lab = {
        category: "recommender",
        description: `Remove axis label for ${field}`,
        specifier: { role: "axis.label", field: field },
        action: "remove"
      }
    }
    rules.push(rule_le);
    if (rule_ax_lab !== undefined) rules.push(rule_ax_lab);
    if (search_asp(parsed, 'detect(for_tiny', "startsWith")?.length == 0) {
      let old_mark_label = source.layer[0].text.filter(d => d.type === "on-mark" && d.field === fieldToRC);
      let rule_mark_lab;
      if (old_mark_label.length > 0) {
        rule_mark_lab = {
          category: "recommender",
          description: `Convert mark label to axis label`,
          specifier: { role: "mark.label", mark: "rect" },
          action: "replace",
          option: {
            to: {
              role: "axis.label",
              fontColor: null,
              orient: null,
              textAlign: "right",
              padding: 5
            }
          }
        }
      }
      if (rule_mark_lab) rules.push(rule_mark_lab);
    }
  }
  return rules;
}

export function translateMakeheatmapNominalColorToFill(tech, args, line, parsed, source, mapping, processed, config) {
  // do(make_heatmap_nominal_color_to_fill,I1,I2,F,CH)
  let rules = [];
  let row = parseInt(mapping[args[0]]["layout.row"]),
    column = parseInt(mapping[args[1]]["layout.column"]),
    field = trimFieldString(args[2]),
    old_channel = args[3];
  let layer = source.layer[0];
  // mark type change; new channel assignment
  let rule_ch = {
    category: "recommender",
    description: `Change mark type to rect`,
    specifier: {
      role: "mark",
      mark: source.layer[0].mark.type
    },
    action: "modify",
    option: {
      mark: "rect",
      interpolate: null,
      [old_channel]: null
    }
  };
  rule_ch.option.fill = {
    field: source.layout.row[row].field,
    type: "quantitative",
    scale: {},
    legend: null
  };
  if (layer?.name) rule_ch.specifier.id = layer.name
  else if (layer?.mark?.type) rule_ch.specifier.mark = layer.mark.type;
  else rule_ch.specifier.index = 0;
  rules.push(rule_ch);
  // change row field to color field
  let rule_layout = {
    category: "recommender",
    description: `Change the row field`,
    specifier: {
      role: "row",
      field: source.layout.row[row].field
    },
    action: "modify",
    option: {
      field,
      scale: null,
      type: "nominal"
    }
  }
  rules.push(rule_layout);
  // remove axis grids
  let rule_grid = {
    category: "recommender",
    description: `Modify axis grids`,
    specifier: {
      role: "axis"
    },
    action: "modify",
    option: {
      grid: null
    }
  };
  rules.push(rule_grid);
  // remove row axis  
  let rule_axis = {
    category: "recommender",
    description: `Change the row field`,
    specifier: {
      role: "axis.label",
      field: source.layout.row[row].field
    },
    action: "remove"
  };
  rules.push(rule_axis);
  // modify column type
  let rule_layout2 = {
    category: "recommender",
    description: `Modify the column field type`,
    specifier: {
      role: "column",
      field: source.layout.column[column].field
    },
    action: "modify",
    option: {
      type: "ordinal"
    }
  };
  rule_layout2.option.scale = { domain: source.datatype[source.layout.column[column].field].values.map(d => d) || [] };
  if (!rule_layout2.option.scale.domain.includes(source.layout.column[column].scale.domain[0])) {
    rule_layout2.option.scale.domain.splice(0, 0, source.layout.column[column].scale.domain[0]);
  }
  if (!rule_layout2.option.scale.domain.includes(source.layout.column[column].scale.domain[1])) {
    rule_layout2.option.scale.domain.push(source.layout.column[column].scale.domain[1]);
  }
  rules.push(rule_layout2);
  return rules;
}

export function translateRepositionMarkLabelForHeatmap(tech, args, line, parsed, source, mapping, processed, config) {
  // do(reposition_mark_label_heatmap,l0,t2,"amount").
  let rules = [];
  let layer = source?.layer?.[mapping[args[0]]?.layer];
  if (layer) {
    let text = layer.text?.[mapping[args[1]]?.text];
    if (text) {
      rules.push({
        category: "recommender",
        description: `Modify mark label for ${args[2]}`,
        specifier: { role: "mark.label", mark: "rect", field: args[2].replace(/\"/gi, '') },
        action: "modify",
        option: {
          orient: "middle-center",
          anchor: "middle",
          textAlign: "center",
          fontColor: "$black-white",
          dx: 0,
          dy: "-50%"
        }
      });
    }
  }
  return rules;
}